import Header from '@/components/common/Header.vue';
import { defineComponent } from 'vue';
import { videoReq } from '@/api/index';
import pblListItem from '@/components/list/pblListItem.vue';
import utils from '@/public/utils/index';
import BScroll from '@/components/common/BScroll.vue';
import Empty from '@/components/common/Empty.vue';
export default defineComponent({
    data() {
        return {
            title: '专题推荐课程',
            list: [],
            pageNo: 1,
            pageCount: 1,
            bs: null,
            flag: true,
            scroll: false,
            isApp: utils.isApp()
        };
    },
    watch: {
        scroll(newData) {
            if (newData) {
                this.$refs.scroll.domStyle = {
                    bottom: 0,
                    top: this.isApp ? '0' : '0.88rem',
                    position: 'fixed',
                    left: '50%',
                    marginLeft: '-3.75rem'
                };
                this.$nextTick(() => {
                    this.$refs.scroll.setBs();
                });
            }
        },
        list() {
            this.$nextTick(() => {
                this.$refs.scroll.bs && this.$refs.scroll.bs.refresh();
                this.$refs.scroll.bs && this.$refs.scroll.bs.finishPullUp();
            });
        }
    },
    methods: {
        getList() {
            if (!this.flag) {
                this.$toast('数据加载中');
                return;
            }
            this.flag = false;
            videoReq.getPBLList({
                params: {
                    userId: utils.getUserId()
                },
                query: {
                    pageNo: this.pageNo
                }
            }).then(res => {
                if (res.code === 200) {
                    // 未加载完成可以继续加载
                    this.pageCount = res.data.pageCount;
                    // 是否需要上拉加载
                    if (this.list.length === 0) {
                        this.scroll = this.pageCount > 1;
                    }
                    this.flag = true;
                    this.list = this.list.concat(res.data.list);
                }
                else {
                    this.$toast(res.message);
                }
            });
        },
        scrollCallBack() {
            if (this.pageCount > this.pageNo && this.flag) {
                this.pageNo += 1;
                this.getList();
            }
        }
    },
    mounted() {
        this.getList();
    },
    components: {
        Header,
        pblListItem,
        BScroll,
        Empty
    }
});
